





















import { Component, Vue } from 'vue-property-decorator'
import BillboardCreate from '@/components/billboard/billboard-create/BillboardCreate.vue'

@Component({
  components: {
    BillboardCreate
  }
})
export default class BillboardCreatePage extends Vue {
  data() {
    return {}
  }
}
